import React, { FC } from "react";
import { StyledCardLabel, StyledEmail } from "./index.styled";
import { SavedOption } from "v3/components/checkout/SavedOption";
import { getPaymentMethodImg } from "v3/helpers/payment";
import { paymentMethods } from "v3/constants/payment";

interface PayPalOptionProps {
  checked: boolean;
  email: string;
  isDefault: boolean;
  isDisabled?: boolean;
  onSelect: (creditCardToken: string) => void;
  token: string;
}

export const PayPalOption: FC<PayPalOptionProps> = ({
  checked = false,
  email,
  isDefault = false,
  isDisabled,
  onSelect,
  token,
}) => (
  <SavedOption
    checked={checked}
    handleClick={() => onSelect(token)}
    imageAlt="PayPal"
    imageSrc={getPaymentMethodImg(paymentMethods.PAYPAL)}
    isDefault={isDefault}
    isDisabled={isDisabled}
    title="PayPal"
  >
    <StyledCardLabel>
      <StyledEmail>{email}</StyledEmail>
    </StyledCardLabel>
  </SavedOption>
);
